import { ReactElement, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { alphaToHex } from '../lib/utils';
import Switch from './Switch';

interface FeatureContainerProps {
	descricao: string;
	titulo: string;
	icon: ReactElement;
	onCheckedChange?: (checked: boolean) => void;
	checked?: boolean;
	useSwitch?: boolean;
	color?: string;
	onContainerClick?: () => void;
}

const FeatureContainer = ({ descricao, titulo, icon, onCheckedChange, onContainerClick, checked, useSwitch = true, color = '#f9fafb' }: FeatureContainerProps) => {
	const [isChecked, setIsChecked] = useState(checked);

	const handleChecked = () => {
		setIsChecked(!isChecked);
		onCheckedChange?.(!isChecked);
	};

	const handleContainerClick = () => {
		onContainerClick?.();
	};

	useEffect(() => {
		setIsChecked(checked);
	}, [checked]);

	return (
		<motion.div
			whileHover={{
				scale: 1.03,
				transition: { duration: 0.1 },
			}}
			className='w-full max-w-[482px] min-h-[96px] grow basis-[482px] bg-white flex flex-row items-center gap-3 p-4 rounded-xl border border-gray-200 shadow-sm cursor-pointer select-none transition-colors duration-75 hover:border-indigo-600/50'
			onClick={handleContainerClick}>
			<Button
				className={twMerge(
					'p-0 size-12 flex-shrink-0 bg-gray-50 transition !text-gray-900',
					isChecked && '!text-[var(--btn-color-active-lib-empreender)]'
				)}
				style={{
					backgroundColor: isChecked ? alphaToHex(color, 0.2) : '#f9fafb',
					'--btn-color-active-lib-empreender': color,
				} as React.CSSProperties}
			>
				{icon}
			</Button>

			<div className='flex flex-col gap-2 w-full'>
				<h3 className='text-gray-700 font-inter text-[16px] not-italic font-semibold leading-[20px]'>{titulo}</h3>
				<p className='text-gray-600 font-inter text-[14px] not-italic font-normal leading-[18px]'>{descricao}</p>
			</div>
			{useSwitch && (
				<div className='flex'>
					<Switch checked={isChecked} onClick={(e) => e.stopPropagation()} onCheckedChange={handleChecked} />
				</div>
			)}
		</motion.div>
	);
};

export default FeatureContainer;
